
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'triangle-left': {
    width: 5,
    height: 10,
    viewBox: '0 0 5 10',
    data: '<path d="M0 10L5 5L0 0L0 10Z"/>'
  }
})
